const QUALTRICS_SITE_INTERCEPT_ID = 'ZN_3Gy5C4MunhLnI7P';

export const getQualtricsInterceptSnippet = (): string => `(function(){var g=function(g){
this.go=function(){var a=document.createElement("script");a.type="text/javascript";a.src=g;document.body&&document.body.appendChild(a)};
this.start=function(){var t=this;"complete"!==document.readyState?window.addEventListener?window.addEventListener("load",function(){t.go()},!1):window.attachEvent&&window.attachEvent("onload",function(){t.go()}):t.go()};};
try{(new g("https://zn3gy5c4munhlni7p-lovet.siteintercept.qualtrics.com/SIE/?Q_ZID=${QUALTRICS_SITE_INTERCEPT_ID}")).start()}catch(i){}})();`;

export const QUALTRICS_INTERCEPT_ID = QUALTRICS_SITE_INTERCEPT_ID;

export const getElementID = (id: string): string => `qualtrics-intercept-${id}`;
